module.exports = __webpack_public_path__ + "static/media/a53.bcb0b60d.jpg";